var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "From Timezone" },
          model: {
            value: _vm.clone.isWeekend.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isWeekend, "fromTimezone", $$v)
            },
            expression: "clone.isWeekend.fromTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.isWeekend.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isWeekend, "fromFormat", $$v)
            },
            expression: "clone.isWeekend.fromFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.isWeekend.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isWeekend, "fromLocale", $$v)
            },
            expression: "clone.isWeekend.fromLocale",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex gap-5" }, [
      _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.dateIsWeekendWeekendDays"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "weekend-days" },
          [
            _c(
              "a-checkbox-group",
              {
                model: {
                  value: _vm.clone.isWeekend.weekendDays,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.isWeekend, "weekendDays", $$v)
                  },
                  expression: "clone.isWeekend.weekendDays",
                },
              },
              [
                _c("a-checkbox", { attrs: { value: "0" } }, [
                  _vm._v(_vm._s(_vm.$t("auto.dateIsWeekendSunday"))),
                ]),
                _vm._v(" "),
                _c("a-checkbox", { attrs: { value: "6" } }, [
                  _vm._v(_vm._s(_vm.$t("auto.dateIsWeekendSaturday"))),
                ]),
                _vm._v(" "),
                _c("a-checkbox", { attrs: { value: "5" } }, [
                  _vm._v(_vm._s(_vm.$t("auto.dateIsWeekendFriday"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }